export default function Footer() {
    return (
      <footer className="bg-primary text-white py-6 text-center text-sm">
        &copy; {new Date().getFullYear()} KursusCodingOnline. All rights reserved.
      </footer>
    );
  }
  